import styled from 'styled-components';

export const ActionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: auto;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const FilterGroup = styled.div`
  display: flex;
  > *:not(:first-child) {
    margin-left: 8px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  > *:not(:first-child) {
    margin-left: 16px;
  }
`;
